<template>
  <div class='vuestic-chart'>
    <component :is="type + '-chart'" :chartOptions="options" :chartData="data"/>
  </div>
</template>

<script>
  import BubbleChart from './chart-types/BubbleChart';
  import DonutChart from './chart-types/DonutChart';
  import HorizontalBarChart from './chart-types/HorizontalBarChart';
  import LineChart from './chart-types/LineChart';
  import PieChart from './chart-types/PieChart';
  import PolarAreaChart from './chart-types/PolarAreaChart';
  import RadarChart from './chart-types/RadarChart';
  import ScatterChart from './chart-types/ScatterChart';
  import VerticalBarChart from './chart-types/VerticalBarChart';

  export default {
    name: 'vuestic-chart',
    props: ['data', 'options', 'type'],
    components: {
      BubbleChart,
      DonutChart,
      HorizontalBarChart,
      LineChart,
      PieChart,
      PolarAreaChart,
      RadarChart,
      ScatterChart,
      VerticalBarChart,
    },
  };
</script>

<style lang='scss'>
  @import '../../../sass/_variables.scss';

  .vuestic-chart {
    width           : 100%;
    height          : 100%;
    display         : flex;
    align-items     : center;
    justify-content : center;

    > * {
      height : 100%;
      width  : 100%;
    }

    canvas {
      width  : 100%;
      height : auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/vuestic-theme/vuestic-components/vuestic-chart/VuesticChart.vue